/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useContext } from 'react';
import {
  CalculatorIcon,
  ShoppingBagIcon,
  ViewGridAddIcon,
  CalendarIcon,
  RefreshIcon,
} from '@heroicons/react/outline';
import { PageTitle } from 'components/layouts/pageTitle';
import { useLocation } from 'react-router-dom';
import { ExclamationCircleIcon } from '@heroicons/react/solid';
import { joinClassNames } from 'utils/cssHelper';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { ProductsAddNewMainInfo } from './main';
import { ProductsAddNewPricing } from './pricing';
import { ProductsAddNewSchedule } from './schedule';

export const ProductsAddEditForm = ({ itemData, isEdit }) => {
  const navigation = [
    { name: 'General', href: '#', icon: ViewGridAddIcon, visible: true },
    { name: 'Pricing / Packaging', href: '#', icon: CalculatorIcon, visible: isEdit },
    { name: 'Schedule', href: '#', icon: CalendarIcon, visible: isEdit },
    // { name: 'Override', href: '#', icon: RefreshIcon, visible: isEdit }, i think this is not what was wanted, commenting out
    // { name: 'Stock', href: '#', icon: ShoppingBagIcon, visible: isEdit },
  ];
  const { state: auth } = useContext(AuthContext);
  const { state: companyState, getCompanyRestaurants } = useContext(CompanyContext);

  const [selectedTab, setSelectedTab] = useState(0);
  const [isAfterAddNewSubmit, setIsAfterAddNewSubmit] = useState(false);
  const [selectedRestaurants, setSelectedRestaurants] = useState(itemData?.restaurants || []);

  const [productVariations, setProductVariations] = useState([]);

  const location = useLocation();
  const { search } = location;

  useEffect(() => {
    getCompanyRestaurants({ token: auth.token, companyId: auth.company?.company });
  }, []);

  useEffect(() => {
    const sp = new URLSearchParams(search);
    const calbackFlag = sp.get('callback');

    if (calbackFlag === 'true') {
      setIsAfterAddNewSubmit(true);
    }
  }, []);

  const changeTabSelection = (e, selectedTabIndex) => {
    e.preventDefault();
    setSelectedTab(selectedTabIndex);
  };

  return (
    <>
      <PageTitle title="Product" breadcrumbs={[{ path: '/products', title: 'Products' }]} />
      <div className="container mx-auto px-2 md:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
          <aside className="pb-6 md:-mt-6 lg:-mt-0 px-0 lg:py-0 md:px-0 lg:col-span-3">
            <nav className="space-y-1">
              {navigation
                .filter((x) => x.visible)
                .map((item, tabIndex) => (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    key={item.name}
                    onClick={(e) => changeTabSelection(e, tabIndex)}
                    href="#"
                    className={joinClassNames(
                      tabIndex === selectedTab
                        ? 'bg-gray-50 text-indigo-700 hover:text-indigo-700 hover:bg-white'
                        : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50',
                      'group rounded-md px-3 py-2 flex items-center text-sm font-medium',
                    )}
                    aria-current={item.current ? 'page' : undefined}
                  >
                    <item.icon
                      className={joinClassNames(
                        tabIndex === selectedTab
                          ? 'text-indigo-500 group-hover:text-indigo-500'
                          : 'text-gray-400 group-hover:text-gray-500',
                        'flex-shrink-0 -ml-1 mr-3 h-6 w-6',
                      )}
                      aria-hidden="true"
                    />
                    <span className="truncate">{item.name}</span>
                  </a>
                ))}
            </nav>
          </aside>

          <div className="sm:px-0 lg:col-span-9">
            {isAfterAddNewSubmit && (
              <div className="rounded-md bg-yellow-50 p-4 mb-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <ExclamationCircleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-yellow-800">Attention needed</h3>
                    <div className="mt-2 text-sm text-yellow-700">
                      <p>
                        You have just saved your product. Now you can add variations, pricing and
                        stock.
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="-mx-2 -my-1.5 flex">
                        <button
                          type="button"
                          className="bg-yellow-50 px-2 py-1.5 rounded-md text-sm font-medium text-yellow-800 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600"
                          onClick={() => setIsAfterAddNewSubmit(false)}
                        >
                          Don&apos;t show it again
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className={selectedTab === 0 ? 'block' : 'hidden'}>
              <ProductsAddNewMainInfo
                itemData={itemData}
                isEdit={isEdit}
                restaurants={companyState.restaurants}
                onRestaurantsChange={(newVal) => setSelectedRestaurants(newVal)}
                onProductVariationsChange={setProductVariations}
              />
            </div>
            {isEdit && (
              <div className={selectedTab === 1 ? 'block' : 'hidden'}>
                <ProductsAddNewPricing
                  itemData={itemData}
                  isEdit={isEdit}
                  productVariations={productVariations}
                />
              </div>
            )}
            {isEdit && (
              <div className={selectedTab === 2 ? 'block' : 'hidden'}>
                <ProductsAddNewSchedule
                  itemData={itemData}
                  restaurants={companyState.restaurants}
                  selectedRestaurants={selectedRestaurants}
                />
              </div>
            )}
            {/* isEdit && (
              <div className={selectedTab === 3 ? 'block' : 'hidden'}>
                <ProductsAddNewOverride
                  itemData={itemData}
                />
              </div>
            ) */}
            {/* isEdit && (
            <div className={selectedTab === 2 ? 'block' : 'hidden'}>
              <ProductStock
                itemData={itemData}
                restaurants={restaurants}
              />
            </div>
            ) */}
          </div>
        </div>
      </div>
    </>
  );
};
